// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionTitle_container__RwQPb","title":"SectionTitle_title__bCAfb","divider":"SectionTitle_divider__xuyFM"};